import { render, staticRenderFns } from "./SkinPreview.vue?vue&type=template&id=34f8273c&scoped=true"
import script from "./SkinPreview.vue?vue&type=script&lang=js"
export * from "./SkinPreview.vue?vue&type=script&lang=js"
import style0 from "./SkinPreview.vue?vue&type=style&index=0&id=34f8273c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f8273c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VIcon,VResponsive})
